module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-250-Classes-Inactive-a014d6f3d4196803b5145ae50b616b56.png";